import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ProductDetail } from '@components/templates/marketplace';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { useData } from '@hooks/useData';
import { useGetProductDetail } from '@services/useGetProductDetail';
import { getProductAvailability } from '@utils/products';

export function ProductDetailPage() {
    const { allSettings, productDetail } = useData();
    const { request: requestProductDetail, loading } = useGetProductDetail();
    const { uuid } = useParams();
    const { t, i18n } = useTranslation();

    // fetch product detail info
    useEffect(() => {
        requestProductDetail({ uuid: uuid || '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uuid, i18n.language]);

    const translations = {
        title: t('product-detail-component.metatags.title', {
            name: productDetail?.data?.name,
            marketplace: allSettings?.data?.marketplaceName,
        }),
        description: t('product-detail-component.metatags.description', {
            name: productDetail?.data?.name,
            marketplace: allSettings?.data?.marketplaceName,
        }),
    };

    // cspell:disable-next-line
    // ex: Preto, Branco, M, XL, etc
    const attributeValues: string[] =
        (productDetail?.data?.attributes || [])
            .flatMap((attribute) => attribute.values || [])
            .map((value) => value.value || '') || [];

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        tags: [productDetail?.data?.merchant?.name || '', productDetail?.data?.category?.name || '', ...attributeValues],
        image: {
            src: productDetail?.data?.image?.src || '',
            type: productDetail?.data?.image?.type,
            height: productDetail?.data?.image?.height,
            width: productDetail?.data?.image?.width,
            alt: productDetail?.data?.name || '',
        },
        url: SITE_URLS.productDetail.replace(':uuid', `${uuid}`),
        index: true,
    });

    return (
        <ProductDetail
            {...productDetail?.data}
            images={productDetail?.data?.images?.flat().flat()}
            availability={getProductAvailability(productDetail?.data?.availability)}
            relatedProducts={
                productDetail?.data?.relatedProducts?.map((item) => {
                    return { ...item, initialFavorite: item.favorite || false };
                }) || []
            }
            isPurchasable={productDetail?.data?.isPurchasable || false}
            canReserve={productDetail?.data?.canReserve || false}
            loading={loading}
        />
    );
}
